// extracted by mini-css-extract-plugin
export var currencyInput = "_nk-1";
export var currencySymbol = "_nk-0";